import { Flex } from '@qga/roo-ui/components';
import { CardProps } from '../types';
import {
  CardWrapper,
  CardImage,
  InfoWrapper,
  Heading,
  SubHeading,
  StayInfo,
  BookingStatus,
  CancellationLabel,
  DepositPayReminder,
  Hr,
  ItemLinks,
} from '../Components';
import { generateViewBookingDetailsItemLink, generateActionItemLinks } from './utils';
import { useBookingList } from 'pages/BookingListPage/BookingListProvider';

const UpcomingBookingCard = ({ booking, trackViewBookingItem, ...rest }: CardProps) => {
  const { sendViewBookingEvent } = useBookingList();

  const {
    id,
    image,
    reservation: { property },
  } = booking;

  const track = () => sendViewBookingEvent(id);
  const detailsLink = generateViewBookingDetailsItemLink(booking, track);
  const itemLinks = generateActionItemLinks(booking, track);

  return (
    <CardWrapper>
      <CardImage {...image} link={detailsLink} onClick={track} />

      <InfoWrapper bookingId={booking.id} {...rest}>
        <BookingStatus booking={booking} />

        <Heading>{property.name}</Heading>
        <SubHeading>{property.address.suburb}</SubHeading>

        <StayInfo booking={booking} />

        <Flex flexDirection={['column', 'row']} mb={[0, 4]}>
          <CancellationLabel booking={booking} />
          <DepositPayReminder booking={booking} />
        </Flex>
      </InfoWrapper>
      <Hr />
      <ItemLinks links={itemLinks} />
    </CardWrapper>
  );
};

UpcomingBookingCard.displayName = 'UpcomingBookingCard';

export { UpcomingBookingCard };
